import { ConvertToMerchantList, GetSelectedMerchant } from "@/helper/merchantHelper";
import { MerchantInFoModel } from "@/model/merchant/MerchantInFoModel";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { UserModel } from "@/model/user";
import router from "@/router";
import API from "@/service/index";
import { ConvertToUserModel } from "@/service/user/authenFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { ActivityLogSource, LoadingStatusType } from "../../enums/enums";

@Module({ namespaced: true })
export default class UserInfo extends VuexModule {
  public loginSuccess: LoadingStatusType = LoadingStatusType.None;
  public userModel = {} as UserModel;
  public merchantList = [] as Array<MerchantInFoModel>;
  public merchantListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public selectMerchant: SelectedMerchantModel | null = null;
  public setSelectMerchantLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public merchantModelByIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public merchantModelListForMap: Map<number, SelectedMerchantModel> = new Map();

  @Mutation
  public setLogInSuccess(userModel: any): void {
    this.userModel = userModel;
    this.loginSuccess = LoadingStatusType.Success;
  }

  @Mutation
  public setLoginFail(): void {
    this.loginSuccess = LoadingStatusType.Fail;
  }

  @Mutation
  public setLoginLoading(): void {
    this.loginSuccess = LoadingStatusType.Loading;
  }

  @Mutation
  public MutationSetMerchantsList(merchantsList: Array<MerchantInFoModel>) {
    this.merchantList = merchantsList;
  }

  @Mutation
  public MutationSetMerchantListLoadingStatus(status: LoadingStatusType) {
    this.merchantListLoadingStatus = status;
  }

  @Mutation
  public MutationsSelectMerchant(_object: SelectedMerchantModel): void {
    this.selectMerchant = _object;
  }

  @Mutation
  public MutationsSetSelectMerchantLoadingStatus(status: LoadingStatusType): void {
    this.setSelectMerchantLoadingStatus = status;
  }

  @Mutation
  public MutationSetMerchantModelByIdLoadingStatus(status: LoadingStatusType) {
    this.merchantModelByIdLoadingStatus = status;
  }

  @Mutation
  MutationSetMerchantModelList(merchantModel: SelectedMerchantModel) {
    this.merchantModelListForMap.set(merchantModel.merchantId, merchantModel);
  }

  @Action
  public DoLogIn(logInData: any): void {
    this.context.commit("setLoginLoading");
    const requestInput: any = {
      userName: logInData.email,
      password: logInData.encpw,
      userType: 0,
    };
    const source = ActivityLogSource.LineConnect;
    API.AuthenService.DoGetAccessToken(requestInput.userName, requestInput.password, requestInput.userType, source)
      .then((res: any) => {
        if (res.status.IsSuccess()) {
          const responseCode = res.data.response_code ? res.data.response_code : 200;
          if (responseCode.IsSuccess()) {
            const token = {
              accessToken: res.data.access_token,
              refreshToken: res.data.refresh_token,
            };
            sessionStorage.setItem("access_token", token.accessToken);
            sessionStorage.setItem("refresh_token", token.refreshToken);
            this.context.dispatch("DoGetUserInfo");
          } else {
            this.context.commit("setLoginFail");
          }
        } else {
          this.context.commit("setLoginFail");
        }
      })
      .catch((error: any) => {
        this.context.commit("setLoginFail");
      });
  }
  @Action
  public DoGetUserInfo(): void {
    API.AuthenService.DoGetUserInfo().then((resUserInfo: any) => {
      if (resUserInfo.status.IsSuccess()) {
        const userModel = ConvertToUserModel(resUserInfo.data.userInfo);
        this.context.commit("setLogInSuccess", userModel);
      } else {
        this.context.commit("setLoginFail");
        router.push("/error");
      }
    });
  }

  @Action
  public DoGetMerchantList() {
    if (this.merchantListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetMerchantListLoadingStatus", LoadingStatusType.Loading);
      API.AuthenService.DoGetMerchantListByUserId().then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          const merchantList = ConvertToMerchantList(res.data.merchantList);
          this.context.commit("MutationSetMerchantsList", merchantList);
        }
        this.context.commit("MutationSetMerchantListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoSelectMerchant(merchantId: number) {
    if (this.setSelectMerchantLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationsSetSelectMerchantLoadingStatus", LoadingStatusType.Loading);
      API.AuthenService.DoGetSelectedMerchant(merchantId).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          const selectMerchant = GetSelectedMerchant(res.data.merchant);
          this.context.commit("MutationsSelectMerchant", selectMerchant);
        } else {
          this.context.commit("MutationsSelectMerchant", null);
        }
        this.context.commit("MutationsSetSelectMerchantLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  DoGetMerchantModelById(merchantId: number) {
    return new Promise((resolve) => {
      this.context.commit("MutationSetMerchantModelByIdLoadingStatus", LoadingStatusType.Loading);

      const merchantModelOnLocal = this.merchantModelListForMap.get(merchantId) ?? null;

      if (merchantModelOnLocal) {
        setTimeout(() => {
          this.context.commit("MutationSetMerchantModelByIdLoadingStatus", LoadingStatusType.Success);
          resolve(merchantModelOnLocal);
        }, 0);
      } else {
        API.AuthenService.DoGetSelectedMerchant(merchantId).then((res: any) => {
          if (res.status.IsSuccess() || res.data.responseCode.IsSuccess()) {
            const merchant = GetSelectedMerchant(res.data.merchant);
            this.context.commit("MutationSetMerchantModelList", merchant);
            this.context.commit("MutationSetMerchantModelByIdLoadingStatus", LoadingStatusType.Success);
            resolve(merchant);
          }
        });
      }
    });
  }

  get getLogInSuccess(): LoadingStatusType {
    return this.loginSuccess;
  }
  get getMerchantList(): Array<MerchantInFoModel> {
    return this.merchantList;
  }
  get getMerchantListLoadingStatus(): LoadingStatusType {
    return this.merchantListLoadingStatus;
  }
  get getUserModel(): UserModel {
    return this.userModel;
  }
  get getMerchant(): SelectedMerchantModel | null {
    return this.selectMerchant;
  }
  get getSetSelectMerchantLoadingStatus(): any {
    return this.setSelectMerchantLoadingStatus;
  }
  get getMerchantModelListForMap() {
    return this.merchantModelListForMap;
  }

  get getMerchantModelByIdLoadingStatus() {
    return this.merchantModelByIdLoadingStatus;
  }
}
